import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import bitmapFonts from 'src/lib/bitmapFonts';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import { PolaroidGarland } from './PolaroidGarland';
import { BookDecoration } from './BookDecoration';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import { PetEvolutionStage, PetSpeciesID } from 'src/replicant/pet';
import { GrowthRecordTile } from './GrowthRecordTile';
import { PartialRecord } from '@play-co/timestep-core';

import { AssetGroup } from '@play-co/timestep-core';

export default class PopupGrowthRecord extends PopupBasic {
  constructor(opts: { superview: View; close: () => void }) {
    super({
      superview: opts.superview,
      close: opts.close,
      zIndex: 10000,
      width: uiConfig.popups.buruburu.width,
      height: 1064,
      offsetY: 40,
      tracking: {
        feature: Feature.FAMILY._,
        $subFeature: Feature.FAMILY.GROWTH_POPUP._,
      },
      titleIcon: {
        image: 'assets/ui/family/icons/growth_record_icon.png',
        width: 60,
        height: 60,
      },
      boxOpts: {
        image: 'assets/ui/family/frames/family_popup_frame.png',
        scaleMethod: '9slice',
        sourceSlices: {
          horizontal: {
            left: 30,
            right: 30,
          },
          vertical: {
            top: 30,
            bottom: 30,
          },
        },
      } as const,
    });

    this.buttonClose.removeFromSuperview();

    this.root.addSubview(
      new PolaroidGarland({
        x: this.root.style.width * 0.48,
        y: 116 / 2,
      }),
      this.box,
    );

    new BookDecoration({ superview: this.box });

    this.box.addSubview(
      new ButtonScaleViewWithText({
        ...uiConfig.buttons.cancel,
        labelOffsetX: -4,
        labelOffsetY: -1,
        fontSize: 38,
        font: bitmapFonts('Body'),
        x: this.box.style.width / 2,
        y: this.box.style.height,
        width: 229,
        height: 80,
        centerOnOrigin: true,
        localeText: () => i18n('basic.back'),
        onClick: async () => {
          sounds.playSound('cancel');
          opts.close();
        },
        tracking: {
          feature: Feature.FAMILY._,
          $subFeature: Feature.FAMILY.GROWTH_POPUP.CLOSE,
        },
      }),
    );

    // Name plate.
    const nameplate = new ImageScaleView({
      superview: this.box,
      width: 321,
      height: 69,
      image: 'assets/ui/family/frames/name_plate.png',
      x: 63,
      y: 83,
      r: -0.1,
    });

    this.message.updateOpts({
      superview: nameplate,
      width: 321,
      height: 69,
      align: 'center',
      verticalAlign: 'center',
      size: 20,
      color: '#686C7E',
      x: 0,
      y: 0,
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup([...AssetGroup.constructURLs('assets/ui/family')]);
  }

  public init({
    name,
    evolutions,
  }: {
    name: string;
    evolutions: readonly {
      stage: PetEvolutionStage;
      species: PetSpeciesID;
    }[];
  }) {
    super.init({
      title: i18n('family.growth.title'),
      message: i18n('family.growth.message', { pet_name: name }),
    });

    // [LPG-875] Some players have two baby pets, just show the latest one.
    const evolutionsSet: PartialRecord<
      PetEvolutionStage,
      (typeof evolutions)[number]
    > = {};

    evolutions.forEach((evolution) => {
      evolutionsSet[evolution.stage] = evolution;
    });

    const setValues = Object.values(evolutionsSet);
    setValues.forEach((evolution, i) => {
      new GrowthRecordTile(
        { superview: this.box, y: 130 + i * 220 },
        {
          ...evolution,
          arrow:
            i === setValues.length - 1
              ? 'none'
              : i % 2 === 0
                ? 'left'
                : 'right',
        },
      );
    });
  }
}
